import { createStore } from "vuex";

const FLOATING_MENU_STATE_KEY = 'floating-menu-enabled';
const ENABLED_REALTIME_STATE_KEY = 'enabled-realtime';

const loadFloatingMenuState = () => {
    try {
        const saved = localStorage.getItem(FLOATING_MENU_STATE_KEY);
        if (saved !== null) {
            return JSON.parse(saved);
        }
    } catch (error) {
        console.error('Error loading floating menu state:', error);
    }
    return false;
}

const saveFloatingMenuState = (value) => {
    try {
        localStorage.setItem(FLOATING_MENU_STATE_KEY, JSON.stringify(value));
    } catch (error) {
        console.error('Error saving floating menu state:', error);
    }
}


const loadEnabledRealtimeState = () => {
    try {
        const saved = localStorage.getItem(ENABLED_REALTIME_STATE_KEY);
        if (saved !== null) {
            return JSON.parse(saved);
        }
    } catch (error) {
        console.error('Error loading enabled realtime state:', error);
    }
    return true; // Default to true (enabled)
}

const saveEnabledRealtimeState = (value) => {
    try {
        localStorage.setItem(ENABLED_REALTIME_STATE_KEY, JSON.stringify(value));
    } catch (error) {
        console.error('Error saving enabled realtime state:', error);
    }
}

const loadOfflineVoiceSearchState = () => {
    try {
        const saved = localStorage.getItem('offline-voice-search');
        if (saved !== null) {
            return JSON.parse(saved);
        }
    } catch (error) {
        console.error('Error loading offline voice search state:', error);
    }
    return false;
}

const saveOfflineVoiceSearchState = (value) => {
    try {
        localStorage.setItem('offline-voice-search', JSON.stringify(value));
    } catch (error) {
        console.error('Error saving offline voice search state:', error);
    }
}

const loadOfflineCacheEnabledState = () => {
    try {
        const saved = localStorage.getItem('offline-cache-enabled');
        if (saved !== null) {
            return JSON.parse(saved);
        }
    } catch (error) {
        console.error('Error loading offline cache state:', error);
    }
    return true; // Default to true (enabled)
}

const saveOfflineCacheEnabledState = (value) => {
    try {
        localStorage.setItem('offline-cache-enabled', JSON.stringify(value));
    } catch (error) {
        console.error('Error saving offline cache state:', error);
    }
}

const store = createStore({
    state: {
        currentView: 'Dashboard',
        disableEvents: false,
        enabledRealtime: loadEnabledRealtimeState(),
        disableGesture: false,
        fullscreen: false,
        drawingEnabled: false,
        livePerformance: false,
        livePerformanceInControl: true,
        transferBucket: null,
        eventLog: [],
        showLogEvent: false,
        message: "",
        error: "",
        floatingMenu: loadFloatingMenuState(),
        offlineVoiceSearch: loadOfflineVoiceSearchState(),
        offlineVoiceSearchReady: false,
        offlineCacheEnabled: loadOfflineCacheEnabledState(),
        activeTeam: localStorage.getItem('active-team') || '',
        activeTeamName: localStorage.getItem('active-team-name') || '',
        isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
        focusMode: false,
    },
    mutations: {
        SET_ONLINE_STATUS(state, status) {
            state.isOnline = status;
        },
        ERROR(state, error) {
            state.message = error.message
            state.error = error.error
        },
        SUCCESS(state, message) {
            state.message = message
        },
        WARNING(state, message) {
            state.message = message
        },
        ADD_EVENT_LOG(state, event) {
            state.eventLog.unshift(event)
            if (state.eventLog.length > 50) {
                state.eventLog.pop();
            }
        },
        SET_FLOATING_MENU(state, value) {
            state.floatingMenu = value;
            saveFloatingMenuState(value);
        },
        SET_OFFLINE_VOICE_SEARCH(state, value) {
            state.offlineVoiceSearch = value;
            saveOfflineVoiceSearchState(value);
        },
        SET_OFFLINE_VOICE_SEARCH_READY(state, value) {
            state.offlineVoiceSearchReady = value;
        },
        SET_DISABLE_EVENTS(state, value) {
            state.disableEvents = value;
        },
        SET_ENABLED_REALTIME(state, value) {
            state.enabledRealtime = value;
            saveEnabledRealtimeState(value);
        },
        SET_OFFLINE_CACHE_ENABLED(state, value) {
            state.offlineCacheEnabled = value;
            saveOfflineCacheEnabledState(value);
        },
        SET_ACTIVE_TEAM(state, value) {
            state.activeTeam = value;
            if (value) {
                localStorage.setItem('active-team', value);
            } else {
                localStorage.removeItem('active-team');
            }
        },
        SET_ACTIVE_TEAM_NAME(state, value) {
            state.activeTeamName = value;
            if (value) {
                localStorage.setItem('active-team-name', value);
            } else {
                localStorage.removeItem('active-team-name');
            }
        },
        SET_FOCUS_MODE(state, value) {
            state.focusMode = value;
        },
        TOGGLE_FOCUS_MODE(state) {
            state.focusMode = !state.focusMode;
        }
    },
    actions: {
        async error(context, error) {
            context.commit("ERROR", { message: error.message, error: error.error })
        },
        addEventLog(context, event) {
            context.commit("ADD_EVENT_LOG", event)
        },
        toggleFocusMode({ commit }) {
            commit('TOGGLE_FOCUS_MODE');
        },
        setFocusMode({ commit }, value) {
            commit('SET_FOCUS_MODE', value);
        }
    }
})

export default store;